export default [
  {
    path: "/",
    text: "acasa",
  },
  {
    path: "/itp",
    text: "ITP",
    dropdown: [
      {
        path: "/itp-ploiesti",
        text: "ITP - Ploiesti",
      },
      {
        path: "/itp-ciorani",
        text: "ITP - Ciorani",
      },
      {
        path: "/itp-floresti",
        text: "ITP - Floresti",
      },
    ],
  },
  {
    path: "/vulcanizare",
    text: "vulcanizare",
  },
  {
    path: "/istorie",
    text: "istorie",
  },
  {
    path: "/informatii",
    text: "informatii",
  },
  {
    path: "/contact",
    text: "contact",
  },
  {
    path: "/blog",
    text: "blog",
  },
]
